<template>
  <div class="content details-page">
    <div class="ql-snow">
      <div class="product-info-wrap ql-editor" v-html="info.details"></div>
    </div>
  </div>
</template>

<script>
import { getLayoutInfo } from "@saas/server-api/src/layout";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  data: function () {
    return {
      info: {},
    };
  },
  mounted() {
    this.apiGetLayoutInfo();
  },
  methods: {
    apiGetLayoutInfo() {
      let params = {
        id: this.$route.params.id,
      };
      getLayoutInfo(params).then((res) => {
        if (res.code === 1) {
          this.info = res.data || {};
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.details-page {
  max-width: 100%;
}
.ql-editor {
  font-size: 14px;
  line-height: 1.8;
  ol,
  ul {
    margin-left: 0;
  }
}
</style>
